<template>
  <div style="height:740px;position: relative;">
    <!-- 选择框 
    :disable-branch-nodes="false"-->
    <div class="screenbox p5 home m15">
      <ul class="screen clearfix">
        <li class="w50 fl">
          <div class="wrap">
            <treeselect
              v-model="value"
              :options="options"
              :multiple="false"
              :show-count="true"
              placeholder="指标"
              :disable-branch-nodes="true"
              @select="selectDepart"
            />
          </div>
        </li>
        <li class="w50 fl">
          <div class="wrap">
            <el-select
              v-model="year"
              @change="yearInput"
              filterable
              placeholder="请选择"
              size="medium"
            >
              <el-option v-for="item in years" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </div>
        </li>
        <li v-show="showEcharts" class="btn-blue" @click="drawecharts">图形</li>
      </ul>
      <ul class="screen clearfix" style="padding:0px 5px">
        <li class="w50 fl">
          <!-- <router-link
            v-if="optionsName === '政府规模(Fraser)'"
            :to="{ path:`/powerIndicators?政府规模(Fraser)`}"
            class="state"
            target="_blank"
          >
            <span></span>
            <a>指标解释</a>
          </router-link>
          <router-link
            v-if="optionsName !== '政府规模(Fraser)'"
            :to="{ path:`/powerIndicators?${this.optionsName}`}"
            class="state"
            target="_blank"
          >
            <span></span>
            <a>指标解释</a>
          </router-link>-->
          <router-link
            :to="{ path:`/powerIndicators?${this.optionsName}`}"
            class="state"
            target="_blank"
          >
            <span></span>
            <a>指标解释</a>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 地图 -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <div ref="worldMap" id="worldMap" style="margin:0 auto; width:100%; height:100%;"></div>
      </div>
    </div>

    <!-- 放大框 -->
    <div class="alertBox" v-if="showAlertBox">
      <!-- 关闭标签 -->
      <div class="alertBigBox_close" @click="closeAlert"></div>
      <!-- 放入图表 -->
      <div
        ref="line"
        id="line"
        style="left: 50%;transform: translateX(-50%); width:95%; height:540px;"
      ></div>
    </div>
  </div>
</template>

<script>
// 树形下拉框
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import "../../../node_modules/echarts/map/js/world.js";
import { api } from "@/require/api";

export default {
  components: {
    Treeselect
  },
  data() {
    return {
      value: "",
      options: [],
      years: [],
      year: "",
      worldData: [],
      showAlertBox: false,
      country: "",
      optionsName: "政府首脑的产生方式",
      showEcharts: true,
      jgzx: [],
      gjzc: [],
      zcbx: [],
      qqzl: [],
      // 特殊处理“贪污程度”、“武力冲突”
      twcd: [],
      nameMap: []
    };
  },
  created() {
    this.loadnameMapdata()
    this.GISgetTree();
  },
  mounted() {},
  methods: {
    // 下拉框
    async GISgetTree() {
      this.twcd = [];
      const { code, data } = await api.get(
        "/politicalDbController/getIndicatorTree"
      );
      if (code === 0) {
        this.options = data;
        // 特殊处理“贪污程度”
        data[0].children.forEach(item => {
          if (item.label === "贪腐程度") {
            item.children.forEach(ele => {
              if (ele.label === "商业贿赂风险") {
                ele.children.forEach(eles => {
                  this.twcd.push(eles.id);
                });
              }
            });
          }
        });
        data[0].children.forEach(item => {
          if (item.label === "武力冲突") {
            item.children.forEach(ele => {
              this.twcd.push(ele.id);
            });
          }
        });
        this.value = data[0].children[1].children[0].id;
        this.GISgetYears(this.value);
        this.jgzx = data[0].children[6].children[0];
        this.gjzc = data[0].children[6].children[1];
        this.zcbx = data[0].children[6].children[2];
        this.qqzl = data[0].children[6].children[3];
      }
    },
    selectDepart(val) {
      this.value = val.id;
      this.GISgetYears();
      this.optionsName = val.label;
      if (this.optionsName === "政府规模(Fraser)") {
        this.optionsName = encodeURI("政府规模(Fraser)");
      }
      // 指标解释传参
      this.jgzx.children.forEach(item => {
        if (item.id === val.id) {
          this.optionsName = this.jgzx.label;
        }
      });
      this.gjzc.children.forEach(item => {
        if (item.id === val.id) {
          this.optionsName = this.gjzc.label;
        }
      });
      this.zcbx.children.forEach(item => {
        if (item.id === val.id) {
          this.optionsName = this.zcbx.label;
        }
      });
      this.qqzl.children.forEach(item => {
        if (item.id === val.id) {
          this.optionsName = this.qqzl.label;
        }
      });
    },
    async GISgetYears() {
      const { code, data } = await api.get(
        "/politicalDbController/getYearsByIndicator",
        {
          indicatorId: this.value
        }
      );
      if (code === 0) {
        this.years = data;
        this.year = data[0].id;
      }
      this.GISgetWorld();
    },

    /* 数据改变即触发 */
    yearInput(event, item) {
      this.GISgetWorld();
    },
    // 分布图的汉英对应
    async loadnameMapdata() {
      const { code, data } = await api.get("/HomePageController/getCountryMap");
      if (code === 0) {
        this.nameMap = data;
      }
    },
    // 绘制世界地图
    async GISgetWorld() {
      const { code, data } = await api.get(
        "/politicalDbController/getFactValueByIndicator",
        {
          indicatorId: this.value,
          year: this.year
        }
      );
      if (code === 0) {
        this.worldData = data.data;
        this.worldData.forEach(item => {
          item.name = this.nameMap[item.name]
        })
        let min = data.value.min;
        let max = data.value.max;
        let title = data.value.title;
        this.drawWorldMap(min, max, title);
      }
    },
    drawWorldMap(min, max, title) {
      let worldMap = this.$echarts.init(document.getElementById("worldMap"));
      let worldMapOption = {
        backgroundColor: "#f8f8f8",
        title: {
          text: title,
          left: "center",
          top: 20
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (params.data === undefined) {
              return params.name;
            } else {
              return params.name + "<br/>" + params.name + " : " + params.value.toFixed(2);
            }
          }
        },
        visualMap: {
          min: min,
          max: max,
          precision: 3,
          left: 40,
          bottom: 40,
          text: ["High", "Low"],
          realtime: false,
          calculable: true,
          inRange: {
            color: ["#62041a", "#a8062c", "#d46f2e", "#d5b719", "#9cd634"]
            // color: ["#9cd634", "#d5b719", "#d46f2e", "#a8062c", "#5d5d5d"]
          }
        },
        series: []
      };

      if (
        this.value === 1 ||
        this.value === 2 ||
        this.value === 3 ||
        this.value === 53
      ) {
        worldMapOption.series = [
          {
            name: "",
            type: "map",
            mapType: "world",
            roam: true,
            itemStyle: {
              emphasis: {
                label: {
                  show: true
                }
              }
            },
            data: this.worldData
          }
        ];
      } else {
        worldMapOption.series = [
          {
            name: "",
            type: "map",
            mapType: "world",
            roam: true,
            selectedMode: "multiple",
            itemStyle: {
              emphasis: {
                label: {
                  show: true
                }
              }
            },
            data: this.worldData
          }
        ];
      }
      if (this.twcd.indexOf(this.value) !== -1) {
        worldMapOption.visualMap.inRange.color = [
          "#9cd634",
          "#d5b719",
          "#d46f2e",
          "#a8062c",
          "#62041a"
        ];
      } else {
        worldMapOption.visualMap.inRange.color = [
          "#62041a",
          "#a8062c",
          "#d46f2e",
          "#d5b719",
          "#9cd634"
        ];
      }
      worldMap.clear();
      worldMap.setOption(worldMapOption);
      window.onresize = () => {
        worldMap.resize();
      };
      //点击事件
      if (
        this.value === 1 ||
        this.value === 2 ||
        this.value === 3 ||
        this.value === 53
      ) {
        worldMap.off("click");
        worldMap.on("click", params => {
          params.color = "#fff";
          this.showAlertBox = true;
          this.country = params.name;
          this.GISgetEchartsFirst();
        });
      } else {
        worldMap.off("click");
        worldMap.on("mapselectchanged", params => {
          this.country = "";
          let selected = params.batch["0"].selected;
          for (const [country, isTrue] of Object.entries(selected)) {
            if (isTrue) {
              this.country = this.country + "," + country;
            }
          }
          this.country = this.country.slice(1);
        });
      }
    },

    // 弹出框

    // (绘制---人口构成折线图)
    async GISgetEchartsFirst() {
      let url = "/politicalDbController/getMapSeriesByCountry";
      const { code, data } = await api.get(url, {
        indicatorId: this.value,
        country: this.country
      });
      if (code === 0) {
        let xData = data.years,
          categorys = data.categorys,
          unit = data.unit,
          Series = [];
        for (let i = 0; i < data.categorys.length; i++) {
          Series.push({
            name: data.categorys[i],
            type: "line",
            data: data.Series[i]
          });
        }
        this.drawLine(categorys, xData, Series, unit);
      }
    },
    // (绘制---多选国家的折线图)
    async GISgetEchartsSecond() {
      let url = "/politicalDbController/getSeriesByCountrys";
      const { code, data } = await api.get(url, {
        indicatorId: this.value,
        countrys: this.country
      });
      if (code === 0) {
        let xData = data.years,
          categorys = data.categorys,
          Series = [];
        for (let i = 0; i < data.categorys.length; i++) {
          Series.push({
            name: data.categorys[i],
            type: "line",
            data: data.Series[i]
          });
        }
        this.drawLine(categorys, xData, Series);
      }
    },
    drawecharts() {
      this.showAlertBox = true;
      this.GISgetEchartsSecond();
    },
    drawLine(legendData, xAxisData, seriesData, unitData) {
      let line = this.$echarts.init(this.$refs.line);

      let lineOption = {
        title: {},
        toolbox: {
          feature: {
            saveAsImage: {}, // 保存图片
            restore: {}, // 配置项还原
            dataView: {}, // 数据表格展示
            magicType: {
              // 动态类型切换
              type: ["line", "bar", "stack", "tiled"]
            }
          }
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          type: "scroll",
          data: legendData,
          bottom: 10
        },
        xAxis: {
          name: "",
          type: "category",
          data: xAxisData
        },
        yAxis: {
          type: "value"
        },
        series: seriesData
      };
      if (
        this.value === 1 ||
        this.value === 2 ||
        this.value === 3 ||
        this.value === 53
      ) {
        lineOption.title = {};
        lineOption.yAxis.name = "单位：" + unitData;
        lineOption.tooltip.formatter = function(params) {
          let htmlStr = "";
          for (var i = 0; i < params.length; i++) {
            var param = params[i];
            var xName = param.name; //x轴的名称
            var seriesName = param.seriesName; //图例名称
            var value = param.value; //y轴值
            var color = param.color; //图例颜色

            if (i === 0) {
              htmlStr += xName + "<br/>"; //x轴的名称
            }
            htmlStr += "<div>";
            //为了保证和原来的效果一样，这里自己实现了一个点的效果
            htmlStr +=
              '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
              color +
              ';"></span>';

            //圆点后面显示的文本
            htmlStr += seriesName + "：" + value + unitData;

            htmlStr += "</div>";
          }
          return htmlStr;
        };
      } else {
        lineOption.title = {
          text: "提示：点击地图上国家直接选择进行作图",
          // color: 'red',
          textStyle: {
            fontWeight: "bold",
            color: "red",
            fontSize: 14
          }
        };
      }
      line.setOption(lineOption);
      window.onresize = () => {
        line.resize();
      };
    },
    closeAlert() {
      this.showAlertBox = false;
    }
  },
  watch: {
    value: {
      handler: function(newval, oldval) {
        if (newval === 1 || newval === 2 || newval === 3 || newval === 53) {
          this.showEcharts = false;
        } else {
          this.showEcharts = true;
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
// 地图
.mapbox {
  height: 93%;
  padding: 5px 10px;
  box-sizing: border-box;
  .bj_white2 {
    height: 100%;
  }
}

// 选择框
.screenbox {
  // height: 50px;
  // height: 7%;
  box-sizing: border-box;
  .screen {
    box-sizing: border-box;
    padding: 5px;
    .w50 {
      width: 46%;
      padding: 0 5px;
      .wrap {
        height: 34px;
        border: 0;
        position: relative;
        .el-select {
          display: block;
        }
      }
    }
  }
}

// 图表
.w33 {
  width: 33.33%;
  padding: 0 5px;
  .box1 {
    background: #fff;
    border: 1px solid #d7dfe3;
    .card_title {
      background: url(../../assets/imgs/titlebj.png) repeat-x top;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #d7dfe3;
      border-left: 1px solid #d7dfe3;
      margin-left: -1px;
      h1 {
        text-align: center;
        line-height: 45px;
        font-weight: 600;
        font-size: 0.95vw;
        font-size: 15px;
      }
    }
  }
}
// 弹出框
.alertBox {
  position: absolute;
  z-index: 1000;
  top: 95px;
  left: 50%;
  width: 70%;
  height: 580px;
  background: #fff;
  opacity: 0.9;
  box-shadow: 0px 0px 5px #888888;
  /* 这里有兼容性问题 */
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  .alertBigBox_close {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 14px;
    width: 14px;
    background: url(../../assets/imgs/close.png) center;
  }
  .alertBigBox_close:hover {
    background: url(../../assets/imgs/close_hover.png) center;
    cursor: pointer;
  }
  #line {
    position: absolute;
    top: 40px;
  }
}
// 指标说明
.state {
  width: 100%;
  height: 34px;
  background: #fff;
  border: 1px solid #d2d6df;
  color: #606266;
  display: block;
  padding: 5px 10px;
  border-radius: 3px;
  text-align: left;
}
.state:hover {
  border: 1px solid #227fcc;
  color: #227fcc;
}
.state span {
  background: url(../../assets/imgs/state.png) no-repeat center;
  background-size: 100%;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.buttonState {
  position: absolute;
  z-index: 1000;
  right: 20px;
  top: 10px;
}
.btn-blue {
  padding: 5px 25px;
  background: #fff;
  border: 1px solid #227fcc;
  color: #227fcc;
  display: block;
  float: left;
  border-radius: 3px;
  width: 8%;
  height: 34px;
}
.btn-blue:hover {
  cursor: pointer;
  background: #227fcc;
  color: #fff;
  border: 1px solid #227fcc;
}
</style>